import React from "react";
import "./footer.css";
import SocialArray from "../common/socialArray";

export default function Footer() {
	return (
		<section id="footer">
			<SocialArray />
		</section>
	);
}
